import { px2rem } from '../utils/helpers/style.js';

var phoneInputSizingsWeb = {
  s: {
    height: 48,
    heading: {
      padding: {
        right: px2rem(36)
      },
      width: px2rem(99)
    }
  },
  m: {
    height: 56,
    heading: {
      padding: {
        right: px2rem(37)
      },
      width: px2rem(105)
    }
  },
  l: {
    height: 64,
    heading: {
      padding: {
        right: px2rem(37)
      },
      width: px2rem(105)
    }
  }
};
var phoneInputThemeWeb = {
  color: 'primary',
  background: 'input.background',
  error: 'alert',
  textColor: 'text',
  sizings: phoneInputSizingsWeb,
  inactive: 'border.inactive',
  disabled: {
    label: 'label.disabled',
    background: 'input.disabled'
  }
};

export { phoneInputThemeWeb };
